// ข้อความ prompt ของปุ่ม "Copy prompt สำหรับ AI" ทั้ง 2 จุด (FR-9.3, FR-9.4)
// ถอดข้อความมาจาก design ตัวจริง (Batch CSV Upload.dc.html) — เป็น hardcode ไทยตามที่ Q-11 ยังไม่ปิด

const COLUMN_LINE = 'sku,toWarehouse,qty,group'

// ใช้ร่วมกับ BatchTransferModal (กล่อง "รูปแบบไฟล์ที่ต้องการ") เพื่อให้กฎตรงกับ prompt เสมอ
export const RULE_ITEMS = [
  'ชื่อคอลัมน์ต้องตรงตามที่ระบุทุกตัว',
  'sku และ toWarehouse ต้องมีอยู่ในระบบ',
  'ห้ามมีแถวซ้ำ (sku + toWarehouse เดียวกัน)',
  'toWarehouse ต้องไม่เป็นคลังเดียวกับต้นทาง',
  'qty ต้องเป็นจำนวนเต็มมากกว่า 0'
]

const RULES = RULE_ITEMS.map((rule, i) => `${i + 1}. ${rule}`).join('\n')

export function buildGeneratePrompt ({ fromWarehouseName } = {}) {
  const sourceNote = fromWarehouseName
    ? ` (คลังต้นทางของงานนี้คือ ${fromWarehouseName})`
    : ''

  return [
    'ช่วยสร้างไฟล์ CSV สำหรับอัปโหลด batch transfer order (Withdraw Note) ให้ผม',
    '',
    'คอลัมน์ (header ต้องตรงตามนี้ทุกตัวอักษร ไม่มีคอลัมน์เกิน):',
    COLUMN_LINE,
    '',
    'ความหมายของแต่ละคอลัมน์:',
    '- sku: รหัสสินค้าที่มีอยู่ในระบบ',
    `- toWarehouse: รหัสคลังปลายทาง (เช่น GW-CTW, GW-SSF) ต้องไม่เป็นคลังเดียวกับคลังต้นทาง${sourceNote}`,
    '- qty: จำนวน เป็นจำนวนเต็มมากกว่า 0',
    '- group: ชื่อกลุ่มสำหรับรวมแถวเป็นชุดเดียวกัน (เช่น group1, group2) แถวที่ group เดียวกันจะถูกจัดเป็นชุดเดียวกัน',
    '',
    'กฎที่ระบบตรวจสอบ:',
    RULES,
    '',
    'ผมจะบอกรายการสินค้าที่ต้องการโอนต่อจากนี้ ช่วยแปลงเป็น CSV ตามฟอร์แมตด้านบน '
      + 'ส่งกลับมาเป็น code block ที่ก๊อปไปเซฟเป็น .csv ได้เลย และเช็คกฎทั้ง 5 ข้อให้ด้วย'
  ].join('\n')
}

export function buildFixPrompt ({ fileName, batchCode, fromWarehouseName, errors = [] } = {}) {
  const lines = errors
    .map((e) => `- แถว ${e.row} (${e.value}): ${e.message}`)
    .join('\n')

  return [
    'ช่วยแก้ไฟล์ CSV สำหรับ batch transfer order นี้ให้ผ่านการตรวจสอบ',
    '',
    `ไฟล์: ${fileName} (batch ${batchCode}, คลังต้นทาง ${fromWarehouseName || '-'})`,
    `คอลัมน์ที่ระบบต้องการ: ${COLUMN_LINE.split(',').join(', ')}`,
    '',
    'กฎการตรวจสอบ:',
    RULES,
    '',
    `ข้อผิดพลาดที่ระบบพบ (${errors.length} แถว):`,
    lines,
    '',
    'ช่วยบอกว่าแต่ละแถวควรแก้เป็นอะไร แล้วส่ง CSV ฉบับแก้ไขที่พร้อมอัปโหลดกลับมาให้ด้วย'
  ].join('\n')
}
